exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".task-config-container .list-container[data-v-11439c8c]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column}.task-config-container .compact-search-form[data-v-11439c8c]{display:-webkit-box;display:-ms-flexbox;display:flex;-ms-flex-wrap:nowrap;flex-wrap:nowrap;-webkit-box-align:center;-ms-flex-align:center;align-items:center;margin-bottom:16px}.task-config-container .pagination-container[data-v-11439c8c]{padding-top:20px;text-align:right}", ""]);

// exports
